import appState from "src/model/state";
import { getLanguageWithCountry } from "src/utils/BasePathTools";

export type Language = "es" | "en" | "fi" | "uk" | "hr" | "lv" | "lt" | "ar" | "gl" | "sl" | "no" | "zh" | "el" | "nl" | "bg" | "he" | "mk" | "cs" | "ja" | "ca" | "hu" | "de" | "uz" | "ka" | "ko" | "pt" | "sr" | "sk" | "kk" | "eu" | "it" | "ru" | "pl" | "sq" | "ro" | "sv" | "id" | "et" | "da" | "tr" | "fr" | "vi" | "th";
export type LanguageWithCountry = "es-ES" | "en-GB" | "fi-FI" | "uk-UA" | "hr-HR" | "en-US" | "lv-LV" | "lt-LT" | "ar-AE" | "gl-ES" | "sl-SI" | "no-NO" | "zh-CN" | "el-GR" | "nl-NL" | "bg-BG" | "he-IL" | "mk-MK" | "cs-CZ" | "ja-JP" | "ca-ES" | "hu-HU" | "de-DE" | "uz-UZ" | "zh-TW" | "ka-GE" | "ko-KR" | "pt-BR" | "sr-RS" | "sk-SK" | "kk-KZ" | "es-MX" | "eu-ES" | "it-IT" | "ru-RU" | "pl-PL" | "sq-AL" | "pt-PT" | "ro-RO" | "sv-SE" | "id-ID" | "et-EE" | "da-DK" | "tr-TR" | "fr-FR" | "vi-VN" | "th-TH";

interface ShopDataRequired {
  shopId: number;
  shopMarketId: number;
  shopLang: Language;
  shopLangId: number;
  shopLangWithCountry: LanguageWithCountry;
  expeditionDivision: boolean;
  apiHost: string;
  isMarketTaxes: boolean;
}

export const useShop = (): ShopDataRequired => {
  const { store, market } = appState.get();
  const shopDataRequired = {
    shopId: store.storeId,
    shopMarketId: market.marketId ?? store.storeId,
    shopLang: market.lang as Language,
    shopLangId: market.langId,
    shopLangWithCountry: getLanguageWithCountry() as LanguageWithCountry,
    apiHost: market.apiHost,
    isMarketTaxes: market.isMarketTaxes,
    expeditionDivision: market.expeditionDivision,
  };
  return shopDataRequired;
};
